import React from "react";
import { Sparkles } from "lucide-react";

function PortalTitle() {
  return (
    <div className="flex items-center gap-2 hidden sm:flex">
      <span className="text-2xl font-bold text-gray-900 tracking-tight">
        Cloud Engineering Services
      </span>
      {/*<span className="flex items-center gap-1 text-xs font-semibold text-white bg-orange-500 px-2 py-0.5 rounded-full">
        <Sparkles size={12} />
        AI-Powered
      </span>*/}
    </div>
  );
}

export default PortalTitle;
